import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { TimeEntryListItem } from '../../models/time-entry/time-entry-list-item';
import { Observable } from 'rxjs';
import { TimeEntryListWithTotalModel } from '../../models/time-entry/time-entry-list-with-total.model';
import { TaskResultGeneric } from '../../models/task-result-generic';
import {
  ChangedTimeEntry,
  DistributeTimeEntry,
  TaskResult,
  TimeEntryListParamter,
  TimeEntryListParamterAdmin,
  TimeEntrySplit,
} from '../../models/client-models';
import { TimeEntryModel } from '../../models/time-entry/time-entry.model';
import {
  NewTimeEntry,
  TimelineWorkPeriodDataModel,
} from '../../models/client-models';

const TIME_ENTRIES_ENDPOINT = 'timeEntries';

@Injectable({
  providedIn: 'root',
})
export class TimeEntryBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get TimeEntry list with paging, for a given person and date range.
   */
  public getTimeEntries(
    parameter: TimeEntryListParamter
  ): Observable<TimeEntryListWithTotalModel> {
    return this.http.post<TimeEntryListWithTotalModel>(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/list',
      parameter
    );
  }

  /**
   * Get TimeEntry list with paging, for a given person and date range.
   */
  public getTimeEntriesAsAdmin(
    parameter: TimeEntryListParamterAdmin
  ): Observable<TimeEntryListWithTotalModel> {
    return this.http.post<TimeEntryListWithTotalModel>(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/list/admin',
      parameter
    );
  }

  /**
   * Save new Time Entry.
   *
   * @param newTimeEntry data form from.
   */
  public saveNewTimeEntry(
    newTimeEntry: NewTimeEntry
  ): Observable<TaskResultGeneric<number>> {
    return this.http.post<TaskResultGeneric<number>>(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/new',
      newTimeEntry
    );
  }

  public setGo(id: number): Observable<TaskResultGeneric<TimeEntryModel>> {
    return this.http.post<TaskResultGeneric<TimeEntryModel>>(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/go',
      id
    );
  }

  /**
   * Save changed time entry.
   *
   * @param changedTimeEntry
   */
  public changeTimeEntry(changedTimeEntry: ChangedTimeEntry) {
    return this.http.post(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/edit',
      changedTimeEntry
    );
  }

  /**
   * Save distribute time entry.
   *
   * @param distributeTimeEntry
   */
  public distributeTimeEntry(distributeTimeEntry: DistributeTimeEntry) {
    return this.http.post(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/distribute',
      distributeTimeEntry
    );
  }

  /**
   * Create change between time entries.
   *
   * @param switchTimeEntry
   */
  public switchTimeEntry(switchTimeEntry: ChangedTimeEntry) {
    return this.http.post(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/switch',
      switchTimeEntry
    );
  }

  /**
   * Split time between time entry.
   *
   * @param splitTimeEntry
   */
  public splitTimeEntry(splitTimeEntry: TimeEntrySplit) {
    return this.http.post(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/split',
      splitTimeEntry
    );
  }

  /**
   * Delete time entry.
   *
   * @param timeEntry
   */
  public deleteTimeEntry(timeEntry: TimeEntryListItem) {
    return this.http.post(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/delete',
      timeEntry
    );
  }

  public deleteAfterWorkPeriodChange(
    workPeriodDataModel: TimelineWorkPeriodDataModel
  ): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url +
        TIME_ENTRIES_ENDPOINT +
        '/deleteAfterWorkPeriodChange',
      workPeriodDataModel
    );
  }

  /**
   * Terminate.
   *
   * @param data
   */
  public terminate(data) {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + TIME_ENTRIES_ENDPOINT + '/terminate',
      data
    );
  }
}
